import React, { useState, useEffect, useRef } from 'react';
import { fetchWithDefaults } from '../../../../config/fetchDefault';
import { useSelector } from 'react-redux';
import { getCurrentAge, calculateAge, dobFormat, validDOB } from '../../../../utilities/timeFunctions';
import { useDispatch } from 'react-redux';
import { fetchLeadDataThunk } from '../../../../features/leadDataInfoSlice';
import { inputMask } from '../../../../utilities/genericUtils';

function ContactField({ handleLeadData, field }) {
    const isFeature580Enabled = process.env.REACT_APP_FUNNEL_FEATURE_580 === 'true'
    const agentId = useSelector((state) => state.agent.userData).agentId;
    const numbers = ['borrower_cell', 'borrower_home', 'borrower_work', 'co_borrower_home', 'co_borrower_cell', 'co_borrower_work']
    const ageFields = ['borrower_age', 'co_borrower_age']
    const [borrowerError, setBorrowerError] = useState('');
    const [coBorrowerError, setCoBorrowerError] = useState('');
    const dispatch = useDispatch();

    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const leadDateFields = ['borrower_dob', 'co_borrower_dob']
    const [contactFieldValue, setContactFieldValue] = useState('')
    const [prevValue, setPrevValue] = useState('');
    const [fieldValues, setFieldValues] = useState({});

    useEffect(()=>{
        let initValue = leadsAlldata[field] ?? ""

        if(initValue){
            if(leadDateFields.includes(field)){
                initValue = formatDate(initValue)
            } else if(numbers.includes(field)){
                initValue = formatPhoneNumber(initValue)
            }
        }

        setContactFieldValue(initValue)
        // setPrevValue(initValue)
    }, [leadsAlldata[field], leadsAlldata.lead_id])

    useEffect(()=>{
        setPrevValue(leadsAlldata[field] ?? "")
    }, [leadsAlldata.lead_id])

    // handles updating the state of the contact field value
    const onChangeHandler = (e) => {
        let value = e.target.value

        if(leadDateFields.includes(field)){
            value = formatDate(value)
        }

        if(numbers.includes(field)){
            value = formatPhoneNumber(value)

            if(value == '1' || value.replace(/\D/g, '').length > 10){
                return
            }
        }

        setContactFieldValue(value)
        setFieldValues(prev => ({
            ...prev,
            [field]: value
        }));
        handleLeadData(field, value)
    }

    // handles validating the value before pushing up the lead update.
    const onBlurHandler = async (e) => {
        let value = e.target.value
        let shouldUpdateLead = true

        if(leadDateFields.includes(field)){
            const valididy = validDOB(value)

            if(valididy.isValid){
                if (field === 'borrower_dob') {
                    setBorrowerError('');
                }
                else {
                    setCoBorrowerError('');
                }

                // update the associated age field
                const age = isFeature580Enabled ? getCurrentAge(value) : calculateAge(value);
                const ageFieldName = field === 'borrower_dob' ? 'borrower_age' : 'co_borrower_age';

                if (valididy.date !== '') {
                    await updateLeadData(ageFieldName, age)
                }

            } else {
                if (field === 'borrower_dob') {
                    setBorrowerError(valididy.error);
                }
                else {
                    setCoBorrowerError(valididy.error);
                }

                shouldUpdateLead = false
            }
        }

        if(numbers.includes(field) || ageFields.includes(field)){
            value = value.replace(/\D/g, '')
        }

        if(prevValue === value || (leadsAlldata[field] === null && value === '')){
            shouldUpdateLead = false
        }

        if(shouldUpdateLead === true){
            await updateLeadData(field, value)
            setPrevValue(value)
        }
    }

    function formatPhoneNumber(phoneNumber) {
        const stringPhoneNumber = String(phoneNumber)

        if(stringPhoneNumber === ''){
            return phoneNumber
        }

        const phoneVal = inputMask(stringPhoneNumber, '(###) ###-####', '#', (r, _m, _p) => r.replace(/\D/g, ''))
        return phoneVal
    }
    const formatDate = (value) => {
        if(value === ''){
            return value
        }

        if(typeof value === 'undefined'){
            return value
        }

        let mask = '##'

        if (value.length >= 5) {
            mask = '##/##/####'
        } else if (value.length >= 3) {
            mask = '##/##'
        }

        const date = inputMask(value, mask, '#', (r, _m, _p) => r.replace(/\D/g, ''))
        return date
    };
    const updateLeadData = async (field, value) => {
        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentId,
                    lead: leadsAlldata.lead_id,
                    column: field,
                    value: value
                })
            };
            const response = await fetchWithDefaults('/updateLead', requestOptions);

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const jsonData = await response.json();

            if(jsonData.status === true){
              // await dispatch(fetchLeadDataThunk({ leadId: leadsAlldata.lead_id }));
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const formatField = (inputString) => {
        let fieldLabel

        if (inputString.includes('co_borrower_')) {
            // Remove "borrower_" and capitalize the remaining string
            fieldLabel = inputString.replace('co_borrower_', 'Co Lead ').replace(/\b\w/g, (c) => c.toUpperCase());

        } else if (inputString.includes('borrower_')) {
            // Remove "co_borrower_" and capitalize the remaining string
            fieldLabel = inputString.replace('borrower_', 'Lead ').replace(/\b\w/g, (c) => c.toUpperCase());
        } else if (inputString.includes('_')) {
            // Capitalize the entire string
            fieldLabel = inputString.replace('_', ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        } else {
            // Capitalize the entire string
            fieldLabel = inputString.replace(/\b\w/g, (c) => c.toUpperCase());
        }

        if(fieldLabel === 'Feet' || fieldLabel === 'Inches' || fieldLabel === 'Co Lead Feet' || fieldLabel === 'Co Lead Inches'){
            fieldLabel = `${fieldLabel} (height)`
        }

        return fieldLabel
    }
    const inputRef = useRef(null)
    const handleEdit = () => {
        if(inputRef.current){
            inputRef.current.focus()
        }
    }


    useEffect(() => {
        const initialValues = {};

        // since this only applies to DOB and age fields on the leadf do we really need to capture the entire lead here?
        // the data needed already lives in leadsAlldata and this component is reneder multiple times in the lead.
        // So we're storing mulitple instances of duplicate data that can accessed from redux.
        if (leadsAlldata) {
          Object.keys(leadsAlldata).forEach((key) => {
            let val = leadsAlldata[key];
            if (leadDateFields.includes(key)) {
              val = formatDate(val);
            } else if (numbers.includes(key)) {
              val = formatPhoneNumber(val);
            }
            initialValues[key] = val;
          });
        }

        setFieldValues(initialValues);
      }, [leadsAlldata]);

    /** @type {number | undefined} */
    let maxLength = undefined;
    switch (field) {
        case "borrower_first":
        case "borrower_last":
        case "co_borrower_first":
        case "co_borrower_last":
        case "city":
        case "lender": {
            maxLength = 50;
            break;
        }
        case "borrower_age":
        case "co_borrower_age":
        case "tobacco":
        case "co_borrower_tobacco": {
            maxLength = 3;
            break;
        }
        case "feet":
        case "inches":
        case "weight":
        case "co_borrower_feet":
        case "co_borrower_inches":
        case "co_borrower_weight":
        case "loan_type": {
            maxLength = 15;
            break;
        }
        case "email":
        case "co_borrower_email":
        case "address":
        case "address2": {
            maxLength = 75;
            break;
        }
        case "medical_conditions": {
            maxLength = 300;
            break;
        }
        case "sex":
        case "borrower_sex":
        case "co_borrower_sex":
        case "payment": {
            maxLength = 7;
            break;
        }
        case "state": {
            maxLength = 25;
            break;
        }
        case "zip":
        case "mortgage":
        case "home_value": {
            maxLength = 10;
            break;
        }
    }
    return (
        leadsAlldata && (
            <div className="leadInfoLine">
                <div onClick={() => handleEdit()} className="dataFieldTitle" style={{ maxWidth: 'unset' }}>
                    {formatField(field) + ": "}
                    {field === 'borrower_dob' ? (
                        <span className="error">{borrowerError}</span>
                    ) : field === 'co_borrower_dob' ? (
                        <span className="error">{coBorrowerError}</span>
                    ) : (
                        ''
                    )}
                </div>
                <span className="leadData">
                    {field === 'borrower_dob' || field === 'co_borrower_dob' ? (
                        <input
                            className="qualifierFieldInput"
                            type="text"
                            placeholder="mm/dd/yyyy"
                            value={contactFieldValue}
                            onChange={onChangeHandler}
                            onBlur={onBlurHandler}
                            ref={inputRef}
                        />
                    ) : (
                        <input
                            className="qualifierFieldInput"
                            type="text"
                            value={contactFieldValue}
                            maxLength={maxLength}
                            onChange={onChangeHandler}
                            onBlur={onBlurHandler}
                            ref={inputRef}
                            disabled={
                                (field === 'borrower_age' && String(fieldValues['borrower_dob'] || '').trim() !== '') ||
                                (field === 'co_borrower_age' && String(fieldValues['co_borrower_dob'] || '').trim() !== '')
                            }
                        />
                    )}
                </span>
            </div>
        )
    );

}

export default ContactField;
